@if (premium) {
  <mat-card
    appearance="outlined"
    class="quotation position-relative hiding-div mb-3"
    >
    @for (cover of covers; track cover) {
      <div class="row">
        <div class="col-12 q-section">{{ cover.name }}&nbsp;{{ baseCurrency }}</div>
        <div class="col-12">
          <b>{{ thousandSeparatorAdd(cover.value) }}</b>
        </div>
      </div>
    }
    <div class="col quotation-divider">
      <mat-divider></mat-divider>
    </div>
    @for (fee of fees_and_charges; track fee) {
      <div class="row">
        <div class="col-12 q-section">{{ fee.name }}&nbsp;{{ baseCurrency }}</div>
        <div class="col-12">
          <b>{{ thousandSeparatorAdd(fee.value) }}</b>
        </div>
      </div>
    }
    <div class="row">
      <div class="col-12 q-section">
        <mat-card appearance="outlined" class="primary-bg red-bar">
          <h5 class="d-flex flex-column">
            {{ 'shared.premium-displayer.total-premium' | translate }}
            &nbsp;{{ baseCurrency }}
            <span>
              <b>{{ thousandSeparatorAdd(premium) }}</b>
            </span>
          </h5>
        </mat-card>
      </div>
    </div>
  </mat-card>
}
